import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE} from '@wizeoo/akm-core-lib';
import {
  GridDNDConfig,
  WizBasePopUp,
  WizButton,
  WizDatasource,
  WizDropdown,
  WizLabel,
  WizTextInput,
  WizVgroup,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { GridOptions } from 'ag-grid-community';
import { ColDef } from 'ag-grid-community';
import { FIELD_KIND } from '@wizeoo/akm-compute-lib';

import { FormatVO } from '../../../../vo/workingdata/format.vo';
import { PivotFunction } from '../../../../manager/baselines/pivot-function.obj';
import { StyleVO } from '../../../../vo/workingdata/style.vo';
import { FreedataArgsVO } from '../../../../vo/core/freedataargs.vo';
import { FakeVO } from '../../../../vo/common/tool/fake.vo';
import { Model } from '../../../../model/model';
import { ViewData } from '../../../../model/view.data';
import { widgetHeaderVO } from '../../pivot/renderers/header/header-editext.pop';

@Component({
  // popUp d'édition des champs de pivot: style, label, méthode d'aggrégat
  selector: 'chartitem-setting-pop',
  templateUrl: './chartitem-setting.pop.html',
})
export class ChartItemSettingPop extends WizBasePopUp {
  /** Zone de detail (pour updateEvent) */
  @ViewChild('vgDetailZone', { read: WizVgroup }) vgDetailZone: WizVgroup;

  @ViewChild('gpContent', { read: WizVgroup }) gpContent: WizVgroup; // zone "formule et titre"
  @ViewChild('lbTitle', { read: WizLabel, static: false }) lbTitle: WizLabel; // titre de la popUp (fullcode)
  @ViewChild('lbContent', { read: WizLabel, static: false }) lbContent: WizLabel; // titre de la popUp (fullcode)


  @ViewChild('gpHeader', { read: WizVgroup }) gpHeader: WizVgroup; // zone rendu du header (couleurs)
  @ViewChild('tiLabel', { read: WizTextInput, static: true }) tiLabel: WizTextInput; // ti de label

  @ViewChild('gpFormat', { read: WizVgroup }) gpFormat: WizVgroup; // zone format, type de champ et aggrégat
  @ViewChild('ddFunc', { read: WizDropdown }) ddFunc: WizDropdown; // drop de choix de la fonction
  @ViewChild('ddFormat', { read: WizDropdown }) ddFormat: WizDropdown; // drop de choix du formatage
  @ViewChild('ddField', { read: WizDropdown }) ddField: WizDropdown; // drop de choix du champ de label des FDVs
  @ViewChild('ddChronoField', { read: WizDropdown }) ddChronoField: WizDropdown; // drop de choix du champ de label des Chronos
  @ViewChild('ddStyle', { read: WizDropdown }) ddStyle: WizDropdown; // drop de choix du style


  @ViewChild('btnSave', { read: WizButton, static: true }) btnSave: WizButton; // bt save

  /** la DS des fonctions d'aggrégat */
  public functionDS: WizDatasource<PivotFunction> = new WizDatasource<PivotFunction>([])
    .setFilter(this.dataKindFilter.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .build();

  /** DS de la drop des formats */
  public formatDS: WizDatasource<FormatVO> = new WizDatasource<FormatVO>([])
    .setFilter(this.dataFormatFilter.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS de la drop des champs de rendu pour les FDVs */
  public fieldDS: WizDatasource<FreedataArgsVO> = new WizDatasource<FreedataArgsVO>([])
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .setSelectionMode('single')
    .build();

  /** DS de la drop des champs de rendu pour les Chronos */
  public chronoFieldDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>([])
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .setSelectionMode('single')
    .build();

  /** DS du grid des champs de sélection pour les FDVs */  
  public fieldsDS: WizDatasource<FreedataArgsVO> = new WizDatasource<FreedataArgsVO>([])
    .setSortFn(this.sortSelectedFirst.bind(this))
    // .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .setSelectionMode('multiple')
    .build();

  /** la DS des styles */
  public styleDS: WizDatasource<StyleVO> = new WizDatasource<StyleVO>([])
    .setItemCodeField('fullCode')
    .setSortFields([{ property: 'fullCode', way: 'asc', numeric: false }])
    .build();

  public searchFields: string[] = []; // mémorisation des clés de searchField pour sort custom

  /**
   * sort custom pour placer les searchFields sélectionnés en premier
   * @param itemA 
   * @param item 
   */
  public sortSelectedFirst(itemA: FreedataArgsVO, itemB: FreedataArgsVO): number {
    // console.log('sort', itemA, itemB, this.searchFields);
    let idxOfA: number = -1;
    let idxOfB: number = -1;
    if (this.searchFields) {
      idxOfA = this.searchFields.indexOf(itemA.code) >-1 ? this.searchFields.indexOf(itemA.code) : -1;
      idxOfB = this.searchFields.indexOf(itemB.code) >-1 ? this.searchFields.indexOf(itemB.code) : -1;
    }

    if (idxOfA === -1) {
      idxOfA = 1000 + itemA.order;
    }

    if (idxOfB  === -1) {
      idxOfB = 1000 + itemB.order;
    }

    let result: number = 1;
    if(idxOfB - idxOfA >= 0) {
      result = -1;
    }
    // console.log('##A',idxOfA, itemA.code, "##B",idxOfB, itemB.code, "##Res", result);
    return result;
  }


  // colonne du grid
  public columns: ColDef[] = [
    { headerName: '$.field.shortcode.$',dndSource: true, flex: 1, sortable: true, field: 'trsLabel' }
  ];
  gridOptions: GridOptions = {
    // suppressRowClickSelection: true,
  };

  // configuration du drag
  public dndConfig: GridDNDConfig<FreedataArgsVO> = {
    dragEnabled: true,
    dropEnabled: true,
    dropAction: 'reorder'
  };

  private doSaveFlag: boolean = true; // marqueur de validation des modifs (false sur cancel)

  public declare datas: widgetHeaderVO; // le contrat de données pour la pop


  public static baseHeight: number = 300; // hauteur avec tout, statique pour prise externe sur ouverture
  public static baseWidth: number = 500; // largeur, statique pour prise externe sur ouverture

  /** accesseur sur le modèle du widget */
  public get model(): Model {
    return this.datas.widget.model;
  }

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  public show(): void {
    super.show();

    setTimeout(() => {
      this.feed(); // alimentation des données et DS
      this.manageVisibility();
      this.addListeners();
    }, 0);
  }

  /** gestion de la visibilité des zones de configuration, selon le widget et sa conf */
  public manageVisibility(): void {
    // gestion de la zone "content", uniquement si formula
    let contentStr: string = null;
    if (this.datas.pivotField.fkd.isMeasure) {
      contentStr = this.datas.pivotField.fkd.measure['formula' + this.datas.pivotField.mode]; // formule du champ
    }
    if (contentStr && contentStr.length > 0) {
      this.lbContent.wizLabel = contentStr; // formule du champ
      this.gpContent.visible = true;
    } else {
      this.gpContent.visible = false;
    }

    // gestion de la fonction d'aggrégat, sur les pivots ou en mode liste
    if ( (this.datas.baseCollector?.id === 'lstData' || this.datas.place === 'data')  && this.datas.widget?.pivotMode === true) {
      this.ddFunc.visible = true;
      this.ddFunc.wizMandatory = true;
    } else {
      this.ddFunc.visible = false;
      this.ddFunc.wizMandatory = false;
    }

    // choix du label sur les FDVs
    if (!!this.datas.pivotField.fkd.isFreedata) {
      this.ddField.visible = true;
    } else {
      this.ddField.visible = false;
    }

    // choix du label sur les chronos
    if (!!this.datas.pivotField.fkd.isChrono && this.datas.baseCollector?.id !== 'lstFilter') {
      this.ddChronoField.visible = true;
    } else {
      this.ddChronoField.visible = false;
    }
  }



  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feed(): void {

    /** la DS des fonctions d'aggrégat */
    this.functionDS.setSource([...this.model.aggregateEngine.functionMap().values()]);
    
    /** DS de la drop des formats */
    if(!!this.model.formatEngine.getFormatList()) {
      this.formatDS.setSource(this.model.formatEngine.getFormatList());
    }
    
    /** DS de la drop des champs de rendu pour les Chronos */
    this.chronoFieldDS.setSource(this.model.chronocodeEngine.getChronoFields());
    
    /** la DS des styles */
    if(!!this.model.styleList) {
      this.styleDS.setSource(this.model.styleList);
    }

    this.lbTitle.wizLabel = Model.getInstance().feiEngine.getFeiKeyDefTechnicalLabel(this.datas.pivotField.fkd);
    this.tiLabel.setWizValue(this.datas.pivotField.labelOrDefaultLabel); // libellé du champ


    // gestion du groupe de colonne
    const func: string = this.datas.pivotField.aggOrDefaultFunc();
    this.functionDS.refresh();
    this.functionDS.select([this.functionDS.getItemByKey(func)]);
    this.ddFunc.wizDataProvider = this.functionDS;


    // gestion du format
    this.formatDS.refresh(); // actualisation de la drop des formats
    let format: FormatVO = null; // le format de données
    let formatSplit: string[] = null;
    if (this.datas.pivotField.format) {
      formatSplit = this.datas.pivotField.format.split(ViewData.KEY_SEPARATOR);
      format = Model.getInstance().formatEngine.getFormat(formatSplit[0], formatSplit[1]);
    } else if (!!this.datas.pivotField.fkd.defaultFormat) {
      formatSplit = this.datas.pivotField.fkd.defaultFormat.split(ViewData.KEY_SEPARATOR);
      format = Model.getInstance().formatEngine.getFormat(formatSplit[0], formatSplit[1]);
    }
    this.formatDS.select([format]);
    this.ddFormat.wizDataProvider = this.formatDS;

    if(this.datas.pivotField.fkd.isFreedata) {
      // gestion du field des FDVs
      const argSrc: FreedataArgsVO[] = Model.getInstance().freedataEngine.getArgsFromFD(this.datas.pivotField.fkd.code);
      this.fieldDS.setSource(argSrc ? [...argSrc] : []);
      // console.log('head fields', this.fieldDS.getSource());

      let field: FreedataArgsVO = null; // le champ de FDVs
      if (this.datas.pivotField.fdvField) {
        field = this.fieldDS.getItemByKey(this.datas.pivotField.fdvField);
        // console.log('head field', field);
      }
      this.fieldDS.select([field]);
      this.ddField.wizDataProvider = this.fieldDS;
    } else if (this.datas.pivotField.fkd.isChrono) {
      
      let field: FakeVO = null; // le champ de chrono
      if (this.datas.pivotField.fdvField) {
        field = this.chronoFieldDS.getItemByKey(this.datas.pivotField.fdvField);
        // console.log('head field', field);
      } 
      this.chronoFieldDS.select([field]);
      this.ddChronoField.wizDataProvider = this.chronoFieldDS;
      // console.log('head fields');
    }
    

    if (!!this.datas.pivotField.fdvSearch) { // champs sélectionné pour rendu des pops de sélection
      this.searchFields = this.datas.pivotField.fdvSearch.split(ViewData.KEY_SEPARATOR);
    }

    this.resetSubFields(); // construction de la collection de subFields pour rendu pop

    // TODO trier fieldsDS par fdvSearch
    if (!!this.searchFields && this.searchFields.length > 0) { // champs sélectionné pour rendu des pops de sélection
      const valArgs: FreedataArgsVO[] = this.searchFields.map(item => this.fieldsDS.getItemByKey(item));
      // console.log('valargs', valArgs);
      this.fieldsDS.select(valArgs);
      this.fieldsDS.doSort(this.fieldsDS.getSource()); // on ré-applique le tri
    } 

    // gestion du style
    let style: StyleVO = null; // le style
    let styleSplit: string[] = null;
    if (this.datas.pivotField.style) {
      styleSplit = this.datas.pivotField.style.split(ViewData.KEY_SEPARATOR);
      style = Model.getInstance().styleEngine.getStyle(styleSplit[0], styleSplit[1]);
    } else if (!!this.datas.pivotField.fkd.defaultStyle) {
      styleSplit = this.datas.pivotField.fkd.defaultStyle.split(ViewData.KEY_SEPARATOR);
      style = Model.getInstance().styleEngine.getStyle(styleSplit[0], styleSplit[1]);
    }
    this.styleDS.select([style]);

  }

  private resetSubFields(): void {
    if(this.datas.pivotField.fkd.isFreedata) {
      const field: FreedataArgsVO = this.fieldDS.selectedItem; // le champ de FDVs
      if (!!field && field.dataType === FIELD_KIND.OBJECT) { // un champ custom est sélectionné. Si c'est un objet, c'est lui qui donne le contenu des champs de pops
      const subArgSrc: FreedataArgsVO[] = Model.getInstance().freedataEngine.getArgsFromFD(field.datas.split(ViewData.CONTEXT_SEPARATOR)[0]);
      this.fieldsDS.setSource(subArgSrc ? [...subArgSrc] : []);
  
     } else {
      const argSrc: FreedataArgsVO[] = Model.getInstance().freedataEngine.getArgsFromFD(this.datas.pivotField.fkd.code);
      this.fieldsDS.setSource(argSrc ? [...argSrc] : []);
     }
    } else if(this.datas.pivotField.fkd.isChrono) { // chrono ou autre
      const fake: FakeVO = Model.getInstance().chronocodeEngine.getChronoFieldByCode(this.chronoFieldDS.selectedItem?.code);
      if(this.formatDS.selectedItem && this.formatDS.selectedItem.dataKind !==  fake?.datakind) {
        this.formatDS.clearSelection();
      } 
      this.formatDS.refresh();
    }
    

  }


  /** mise en place des écouteurs */
  public addListeners(): void {
    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
  }

  /**
   * Modification du model dans la zone de saisie
   * @param e Evenement model change
   */
  private updateModel(e: WizEvent): void {
    // console.log('updateModel', e.value);
    switch (e.component) {
      case this.ddField:
      case this.ddChronoField:
        this.resetSubFields();
        break;
    }
    // console.log('fi', this.clone.formulaI);
    this.manageVisibility();
  }


  /* ##############################################################################
                   FilterFuncs pour les DS
     ############################################################################## */

  /**
   * filterFunc de la liste de fonction d'aggrégat, selon le type de la données
   * @param e la fonction
   */
  public dataKindFilter(e: PivotFunction): boolean {
    let result: boolean = false;
    if (!this.datas?.pivotField?.fkd) {
      return false;
    }
    switch (this.datas.pivotField.fkd.datakind) {
      case FIELD_KIND.INT:
      case FIELD_KIND.NUMBER:
      case FIELD_KIND.CONSTANT:
        result = e.forNum;
        break;
      case FIELD_KIND.DATE:
        // console.log('this data', this.datas);
        result = e.forDate;
        break;
      case FIELD_KIND.BOOLEAN:
        result = e.forBoolean;
        break;
      case FIELD_KIND.STRING:
        result = e.forString;
        break;
      default:
        result = e.forString;
        break;
    }
    return result;
  }

  /**
   * filterFunc de la liste des formats, selon le type de la données
   * @param e la fonction
   */
  public dataFormatFilter(fm: FormatVO): boolean {
    if (!this.datas?.pivotField?.fkd?.datakind) {
      return false;
    }

    let targetDatakind: string = this.datas.pivotField.fkd.datakind;

    if (this.datas.pivotField.fkd.isChrono && this.chronoFieldDS.selectedItem) {
      targetDatakind = this.chronoFieldDS.selectedItem.datakind;
      // return false;
    }


    // console.log('filter format',this.datas.pivotField.pkd.dataKind, this.datas.pivotField.fdvField);
    return fm.dataKind === targetDatakind;
  }

  /* ##############################################################################
                   sauvegarde
     ############################################################################## */

  /** Sauvegarde */
  public save(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  /** sur hide, tentative d'enregistrement */
  public onHide() {
    if (this.doSaveFlag) {
      this.datas.pivotField.wizAgregateFunc = this.ddFunc.visible && this.ddFunc.selectedItem ? this.ddFunc.selectedItem.code : null;

      const format: FormatVO = this.formatDS.selectedItem;
      const formatCode: string = format ? format.businessUnitCode + ViewData.KEY_SEPARATOR + format.code : null;
      this.datas.pivotField.format = formatCode;

      const style: StyleVO = this.styleDS.selectedItem;
      const styleCode: string = style ? style.visionCode + ViewData.KEY_SEPARATOR + style.code : null;
      this.datas.pivotField.style = styleCode;

      if(this.datas.pivotField.fkd.isFreedata) {
        const fdvField: FreedataArgsVO = this.fieldDS.selectedItem;
        this.datas.pivotField.fdvField = fdvField ? fdvField.code : null;
      } else if(this.datas.pivotField.fkd.isChrono) {
        const field: FakeVO = this.chronoFieldDS.selectedItem;
        this.datas.pivotField.fdvField = field ? field.code : null;
      }  

      this.datas.pivotField.label = this.tiLabel.wizValue;

      this.datas.updateCallback(this.datas.baseCollector, this.datas.pivotField);
    }
  }
}
